// extracted by mini-css-extract-plugin
export default {"frameGrid":"Frames_frameGrid__O7B30","frameBox":"Frames_frameBox__PIljx","fadeIn":"Frames_fadeIn__8DtZb","frameTitle":"Frames_frameTitle__24cPu","iframe":"Frames_iframe__3LB6P"};